import { Component, inject } from '@angular/core';
import { SelectTransactionCategoryComponent } from '../select-transaction-category/select-transaction-category.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionAccount } from '../../../../../../_interfaces/transactions.interface';

@Component({
  selector: 'app-add-category-modal',
  imports: [SelectTransactionCategoryComponent],
  templateUrl: './add-category-modal.component.html',
})
export class AddCategoryModalComponent {
  readonly ngbActiveModal = inject(NgbActiveModal);

  // Component state
  selectedCategory: number | undefined;
  selectedCategoryAccount: TransactionAccount | undefined;
  showCatError: string = '';

  onCategoryChange(event: { categoryId?: number; account?: TransactionAccount }) {
    this.selectedCategory = event.categoryId;
    this.selectedCategoryAccount = event.account;
    // Clear error when user selects a category
    if (event.categoryId) {
      this.showCatError = '';
    }
  }

  public onCancel(): void {
    this.ngbActiveModal.dismiss();
  }

  public onAccept(): void {
    // Validate that a category is selected
    if (!this.selectedCategory) {
      this.showCatError = 'Please select a category';
      return;
    }

    // Close modal and emit both the category ID and account code
    this.ngbActiveModal.close({
      categoryId: this.selectedCategory,
      account: this.selectedCategoryAccount,
    });
  }
}
